import React, { useEffect, lazy, Suspense } from 'react';

import useApi, { GET_AVAILABLE_PORTFOLIOS } from 'hooks/useApi';
import LoadingSpinner from 'components/LoadingSpinner';

import Container from 'components/Container';
import Page from 'layout/Page';

const DashboardsList = lazy(() => import('../DashboardsList/DashboardsList'));

const Portfolios = () => {
  const [state, makeRequest] = useApi();
  const { data } = state;

  useEffect(() => {
    makeRequest(GET_AVAILABLE_PORTFOLIOS());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page title="Portfolios">
      <Container center maxWidth="xl">
        <Suspense fallback={<LoadingSpinner />}>
          <DashboardsList linkUrlPrefix="canned" items={data && data.length && data} />
        </Suspense>
      </Container>
    </Page>
  );
};

export default Portfolios;
